export default "__VITE_ASSET__HsEuKF6s__"